import { render, staticRenderFns } from "./MomoNav.vue?vue&type=template&id=1636cdc8&"
import script from "./MomoNav.vue?vue&type=script&lang=js&"
export * from "./MomoNav.vue?vue&type=script&lang=js&"
import style0 from "./MomoNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports